import { useOpcoesProjecao } from "../../../../../hooks/use-opcoes-projecao";
import type { CategoriaTabela } from "../../projecao-formulario/projecao-coletores-tabela";
import { gravadasDaOrigem } from "../../projecao-transferencia";
import {
  AJUSTAR_PROJECAO_LABEL,
  PROJECAO_AJUSTADA_TAG,
  PROJECAO_INCLUIDA_TEXTO,
  PROJECAO_INCLUIDA_TITLE,
} from "./cartao-projecao-transferencia.constants";
import type { CartaoProjecaoTransferenciaProps } from "./types-cartao-projecao-transferencia";

export function useCartaoProjecaoTransferencia({
  projecao,
  origem,
  decisao,
  calculando,
  onAjustar,
}: CartaoProjecaoTransferenciaProps) {
  const { opcoes } = useOpcoesProjecao(gravadasDaOrigem(origem), projecao !== null);
  const nome = (lista: { id: string; nome: string }[], id: string | null | undefined) =>
    lista.find((item) => item.id === id)?.nome ?? null;
  const distribuicoes: Record<CategoriaTabela, string | null> = {
    SERVICOS: nome(
      opcoes.distribuicoes.SERVICOS,
      decisao?.servicos?.distribuicaoId ?? origem?.servicos.distribuicao?.id,
    ),
    MATERIAIS: nome(
      opcoes.distribuicoes.MATERIAIS,
      decisao?.materiais?.distribuicaoId ?? origem?.materiais?.distribuicao?.id,
    ),
  };

  return {
    visivel: projecao !== null,
    titulo: PROJECAO_INCLUIDA_TITLE,
    texto: PROJECAO_INCLUIDA_TEXTO,
    ajustada: decisao !== null ? PROJECAO_AJUSTADA_TAG : null,
    ajustarLabel: AJUSTAR_PROJECAO_LABEL,
    tabela: { simulacao: projecao, distribuicoes, avisos: [], erro: null, calculando },
    ajustar: onAjustar,
  };
}
